import { useSelector } from "react-redux";
import { IHome } from "redux/reducers/homeSlice";
import { RootSliceType } from "redux/reducers/rootReducer";

export const useHomeSelectors = () => {
  const selectedExpertRegions = useSelector<
    RootSliceType,
    IHome["expertRegions"]
  >((state) => state.home.expertRegions);

  const selectedExpertCountries = useSelector<
    RootSliceType,
    IHome["expertCountries"]
  >((state) => state.home.expertCountries);

  const selectedFamousExperts = useSelector<
    RootSliceType,
    IHome["famousExperts"]
  >((state) => state.home.famousExperts);

  const selectedNewComerExperts = useSelector<
    RootSliceType,
    IHome["newComerExperts"]
  >((state) => state.home.newComerExperts);

  const expertCount = useSelector<RootSliceType, IHome["expertCount"]>(
    (state) => state.home.expertCount
  );

  const lessons = useSelector<RootSliceType, IHome["lessons"]>(
    (state) => state.home.lessons
  );

  const popularLessons = useSelector<RootSliceType, IHome["popularLessons"]>(
    (state) => state.home.popularLessons
  );

  const teachers = useSelector<RootSliceType, IHome["teachers"]>(
    (state) => state.home.teachers
  );


  return {
    selectedExpertRegions,
    selectedExpertCountries,
    selectedFamousExperts,
    selectedNewComerExperts,
    expertCount,
    lessons,
    popularLessons,
    teachers,
  };
};
